/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_ExpiresInputs */

const cs_import_tokens_expires = /** @type {(inputs: Import_Tokens_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platnost ve dnech (prázdné = 30)`)
};

const en_import_tokens_expires = /** @type {(inputs: Import_Tokens_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires in days (empty = 30)`)
};

/**
* | output |
* | --- |
* | "Expires in days (empty = 30)" |
*
* @param {Import_Tokens_ExpiresInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_expires = /** @type {((inputs?: Import_Tokens_ExpiresInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_ExpiresInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_expires(inputs)
	return cs_import_tokens_expires(inputs)
});